
export default function Contact() {
  return (
    <footer id="contact" className="relative bg-gradient-to-br from-slate-800 to-slate-900 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="world-pattern" x="0" y="0" width="100" height="100" patternUnits="userSpaceOnUse">
              <circle cx="50" cy="50" r="1" fill="currentColor" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#world-pattern)" />
        </svg>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/5d50cc1d-44ec-4790-8aa3-4374877ba7a6.png" 
                alt="KUBIK d.o.o. Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-xl font-serif font-bold">KUBIK d.o.o.</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              Expert iOS development team creating secure and innovative mobile applications
            </p>
          </div>

          <div className="lg:col-span-4">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
              <div>
                <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">Location</h4>
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-teal-400 text-lg mt-1"></i>
                  <p className="text-gray-400 leading-relaxed">Lugarski put I 47</p>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">City Details</h4>
                <div className="flex items-start gap-3">
                  <i className="ri-building-line text-teal-400 text-lg mt-1"></i>
                  <div>
                    <p className="text-gray-400">Visnjevac</p>
                    <p className="text-gray-400">31220</p>
                  </div>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">Country</h4>
                <div className="flex items-start gap-3">
                  <i className="ri-global-line text-teal-400 text-lg mt-1"></i>
                  <p className="text-gray-400">Croatia</p>
                </div>
              </div>

              <div>
                <h4 className="text-sm font-semibold uppercase tracking-wider mb-4 text-gray-300">Contact</h4>
                <div className="space-y-3">
                  <div className="flex items-start gap-3">
                    <i className="ri-mail-line text-teal-400 text-lg mt-1"></i>
                    <a href="mailto:info@kubikdoo.com" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer break-all">
                      info@kubikdoo.com
                    </a>
                  </div>
                  <div className="flex items-start gap-3">
                    <i className="ri-phone-line text-teal-400 text-lg mt-1"></i>
                    <a href="tel:+16812762978" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                      +1 6812762978
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <p className="text-sm text-gray-400">© 2025 KUBIK d.o.o. All rights reserved.</p>
            
            <div className="flex items-center gap-4">
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-facebook-line text-lg"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 border border-gray-600 rounded-full flex items-center justify-center hover:border-teal-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-lg"></i>
              </a>
            </div>

            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
